import React from 'react';
import { useSelector } from 'react-redux';
import './servicios-incluidos.css';

function ServiciosIncluidos({ descripcion, iconos }) {
  const providerId = useSelector((state) => state.packages.details.data.proveedorId);

  let services = [];

  if (providerId === 10) {
    services = iconos.map((icon) => (
      <div key={icon} className='item-container'>
        <span className='descripcion capitalize'>
          {icon}
        </span>
      </div>
    ));
  } else {
    services = descripcion.map((service) => (
      <div key={service.nombre + service.tipo} className='item-container'>
        <span className='descripcion capitalize'>
          {service.descripciones && service.descripciones[0].valor}
        </span>
      </div>
    ));
  }

  return descripcion.length > 0
    ? (
      <div className='services-container'>
        {services}
      </div>
    )
    : null;
}

export default ServiciosIncluidos;
